import type { ReactNode } from 'react';
import type React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import Styles from './TableHeader.module.scss';

type Props = DeepReadonly<{
  children: ReactNode;
}>;

export const TableHeader: React.FC<Props> = ({ children }: Props) => (
  <thead>
    <tr className={Styles.TableHeader}>{children}</tr>
  </thead>
);
